import { Component, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RadniciService } from 'src/app/shared/services/radnici.service';

@Component({
  selector: 'app-modal-radnik-select',
  templateUrl: './modal-radnik-select.component.html',
  styleUrl: './modal-radnik-select.component.scss',
  standalone: false
})
export class ModalRadnikSelectComponent {
  @Input() updateInputValue = new EventEmitter();
  context = localStorage.getItem('userContext');
  parsedContext = JSON.parse(this.context);
  radnici;

  constructor(private bsModalRef: BsModalRef,
    private radniciService: RadniciService
  ) { }

  reportForm: UntypedFormGroup;

  ngOnInit(): void {
    if (this.radnici == undefined) { this.getAllRadnici(); }
  }

  onSubmit() {
    if (this.reportForm.valid) {
      this.updateInputValue.emit(this.reportForm.value);
      this.closeModal();
    } else {
      this.reportForm.markAllAsTouched();
    }
  }

  getAllRadnici() {
    this.radniciService.getAll().subscribe(resp => {
      this.radnici = resp;
    })
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
